<template>
  <div class="personnel-categorical">
    <OmxList
        :data="activeData"
        :show-search="false"
        :segments="segments"
        :segment-value.sync="activeSegment"
        empty-icon="account-hard-hat"
    >
      <template #actions>
        <b-button type="is-primary" icon-left="plus-thick" @click="addClicked">
          {{ $t('common.add') }}
        </b-button>
      </template>

      <b-table-column :label="$t('categories-view.name')" v-slot="props">
        {{ props.row }}
      </b-table-column>
      <b-table-column v-slot="props" cell-class="has-text-right" width="120">
        <b-button type="is-danger" size="is-small" icon-left="delete"
                  @click="deleteClicked(props.row)">
          {{ $t('categories-view.delete') }}
        </b-button>
      </b-table-column>
    </OmxList>
  </div>
</template>

<script>
import OmxList from "@/components/OmxList.vue";

export default {
  name: "PersonnelCategorical",
  components: { OmxList },
  props: {
    categorical_data: {
      category: [],
      agency: []
    }
  },
  data() {
    return {
      categories: [],
      agencies: [],
      activeSegment: "category"
    }
  },
  computed: {
    segments() {
      return [
        { value: "category", label: this.$t('categories-view.categories'), count: this.categories.length },
        { value: "agency", label: this.$t('categories-view.agencies'), count: this.agencies.length }
      ];
    },
    activeData() {
      return this.activeSegment === "agency" ? this.agencies : this.categories;
    }
  },
  watch: {
    categorical_data: function () {
      this.categories = this.categorical_data.category
      this.agencies = this.categorical_data.agency
    }
  },
  methods: {
    deleteClicked(item) {
      const field = this.activeSegment;
      const source = field === "agency" ? this.agencies : this.categories;
      const confirmBlock = () => {
        const updated = source.filter(x => x !== item);
        this.$emit('updateCategoricalData', {
          data: updated,
          collectionName: "personnel",
          dataFieldTitle: field
        })
      }
      this.$emit('deleteCategoricalData', confirmBlock)
    },
    addClicked() {
      const field = this.activeSegment;
      const source = field === "agency" ? this.agencies : this.categories;
      const confirmBlock = (value) => {
        if (value !== '' && !source.includes(value)) {
          this.$emit('updateCategoricalData', {
            data: [...source, value],
            collectionName: "personnel",
            dataFieldTitle: field
          })
        } else {
          this.showError(this.$t("categories-view.generic-add-element-error"))
        }
      }
      this.$emit('addCategoricalData', confirmBlock)
    }
  }
};
</script>
